import React from "react";

import { brand } from "../../../configs/brand";

interface LogoProps {
  width?: number;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({
  width = brand.logoWidth ?? 100,
  height = brand.logoHeight ?? 80,
}) => {
  return (
    <span className="logo">
      <img
        src={brand.logoUrl}
        alt={`${brand.displayName} logo`}
        className="logo-image"
        width={width}
        height={height}
      />
      {brand.wordmarkBold ? (
        <span className="logo-text-bold">{brand.wordmarkBold}</span>
      ) : null}
      {brand.wordmarkRest}
    </span>
  );
};

export default Logo;
